import { useState, useEffect } from 'react';
import { Keyword } from '../pages/KeywordTable';

const useKeywords = (
    initialKeywordsKey: string,
    initialExcludedKeywordsKey: string,
    initialKeywords: Keyword[],
    initialExcludedKeywords: Keyword[]
) => {
    const loadKeywordsFromStorage = (key: string, initial: Keyword[]): Keyword[] => {
        const stored = localStorage.getItem(key);
        return stored ? JSON.parse(stored) : initial;
    };

    const [keywords, setKeywords] = useState<Keyword[]>(() => loadKeywordsFromStorage(initialKeywordsKey, initialKeywords));
    const [excludedKeywords, setExcludedKeywords] = useState<Keyword[]>(() => loadKeywordsFromStorage(initialExcludedKeywordsKey, initialExcludedKeywords));

/*
    useEffect(() => {
        localStorage.setItem(initialKeywordsKey, JSON.stringify(keywords));
    }, [keywords, initialKeywordsKey]);

    useEffect(() => {
        localStorage.setItem(initialExcludedKeywordsKey, JSON.stringify(excludedKeywords));
    }, [excludedKeywords, initialExcludedKeywordsKey]);
*/

    return {
        keywords, setKeywords, excludedKeywords, setExcludedKeywords
    };
};

export default useKeywords;
